import TopicOne from "../pips-terminal-contents/TopicOne";

const PipsTradeAppContentOne = () => {
  return (
    <>
      <TopicOne />

      <div className="how__work__platform">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
              <div className="thumb-left">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/platforms/pips_trade_app/trade_app_1.png"
                  }
                  alt="computer images"
                />
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
              <div className="content-right">
                <h2>Your All-in-One Trading Companion</h2>
                <p>
                  The Pips Trade App brings professional-grade trading to your
                  fingertips. Built for both new and seasoned traders, the app
                  combines advanced tools, real-time analytics, and secure
                  execution into one intuitive interface. Manage accounts, place
                  orders, analyze markets, and stay informed, all from the
                  convenience of your smartphone. Whether you’re at home or on
                  the go, The Pips Trade App ensures you never miss a trading
                  opportunity.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PipsTradeAppContentOne;
